import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'api-usages',
  templateUrl: './api-usages-viewer.component.html',
  styleUrls: ['./api-usages-viewer.component.scss']
})
export class ApiUsagesViewerComponent implements OnInit {

  @Input() executors: any;

  refinedExecutors = [];


  @Input() currentExecutorname: any;
  @Input() currentExecutorVersion: any;
  @Output() modeEvent: EventEmitter<any> = new EventEmitter();

  totalTestcases = 0;
  totalTestSuites = 0;

  columns = ['Test Suites', 'Testcases'];
  jobMappingToSort = ['no_of_testsuites', 'no_of_testcases'];

  @Input() mode: any;
  modes = [
    {
      mode: 'alltests',
      displayName: 'Redeploy only when tests are passing by 100%'
    },
    {
      mode: 'force',
      displayName: 'Redeploy even if tests are failing'
    },
    {
      mode: 'notests',
      displayName: 'Skip tests'
    }
  ];

  constructor() {
  }

  ngOnInit() {

    for (const executor of this.executors) {
      this.totalTestcases += executor['no_of_testcases'] ? executor['no_of_testcases'] : 0;
      this.totalTestSuites += executor['no_of_testsuites'] ? executor['no_of_testsuites'] : 0;
      if (!executor.self) {
        this.refinedExecutors.push(executor);
      }
    }

    if (this.totalTestcases === 0) {
      this.mode = 'notests';
      this.modeEvent.emit(this.mode);
    }
  }

  toggleExecutor(ev, a) {
    $('.' + a).slideToggle();
    $(ev.target).toggleClass('fa-chevron-up fa-chevron-down');
  }


  getIconClass(type) {
    switch (type) {
      case 'API':
        return 'fa fa-table';
      case 'BUSINESSLOGIC':
        return 'fa fa-link';
      case 'SQLQUERY':
        return 'fa fa-database';
      case 'TESTSUITE':
        return 'fa fa-check-circle';
      case 'WORKFLOW':
        return 'fa fa-sitemap';
    }
  }

  getExecutorTypeName(type) {
    switch (type) {
      case 'API':
        return 'Data Access API';
      case 'BUSINESSLOGIC':
        return 'Business Logic API';
      case 'SQLQUERY':
        return 'SQL Query API';
      case 'TESTSUITE':
        return 'Testsuite API';
      case 'WORKFLOW':
        return 'Workflow API';
    }
  }

  getMethodClass(method) {
    switch (method) {
      case 'GET':
        return 'get';
      case 'PUT':
        return 'put';
      case 'POST':
        return 'post';
      case 'DELETE':
        return 'delete';
      case 'PATCH':
        return 'patch';
    }
  }
}
